import { render, staticRenderFns } from "./orderRecords.vue?vue&type=template&id=479dab5a&"
import script from "./orderRecords.vue?vue&type=script&lang=js&"
export * from "./orderRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports